module.exports = __webpack_public_path__ + "static/media/expBlack.d5368250.svg";